import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import {map, take} from 'rxjs/operators';
import { ConfigurationFeature } from 'src/app/common/configuration/models/configuration';
import { ConfigurationService } from 'src/app/common/configuration/services/configuration.service';
import { FileDataResponse } from 'src/app/common/models/cda/FileData';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { FilesList } from 'src/app/core/models/files';
import { UserManager } from 'src/app/core/services/user-manager';
import { DocumentManagementService } from 'src/app/document-management/services/document-management.service';

@Injectable({
  providedIn: "root",
})
export class FileManagerService {
  private _updatedList: FilesList[] = [];
  private _filesList = new BehaviorSubject<FilesList[]>([]);
  filesList = this._filesList.asObservable();

  private _uploadProgress = new BehaviorSubject<{fileName: string, progress: number}>(null);
  uploadProgress = this._uploadProgress.asObservable();

  private _uploadError = new BehaviorSubject<{fileName: string, error: boolean}>(null);
  uploadError = this._uploadError.asObservable();

  constructor(
    private http: HttpClient,
    private userManager: UserManager,
    private documentManagementService : DocumentManagementService,
    private configurationService: ConfigurationService
  )  {
    if(this.configurationService.isFeatureEnabled(ConfigurationFeature.DOCUMENT_INGESTION)) {
      this.getLoadedDocument();
    }
  }


  getLoadedDocument () {
    this.documentManagementService.getDocumentToProcess().subscribe(res => {
      this._updatedList = res.fileDataList.map(file =>
        ({
          refDocumentale:file.refDocumentale,
          title: file.nomeFile,
          nomeFile: file.nomeFile,
          progress: 100,
          versione: file.versione,
        })
      );
      this.updateFilesList(this._updatedList);
    });
  }


  sequence = 0;

  /**
   * Updates the list of files continuosuly
   * @param updatedList list of files
   */
  updateFilesList(updatedList: FilesList[]) {
    // console.log("[updateFileList] [current: "+ this.sequence++ + "]", this._updatedList);
    this._updatedList = updatedList;
    this._filesList.next(updatedList);
  }

  /**
   * Collects files in a new updated list and broadcast it
   * @param file
   */
  private prepareFilesList(file) {

    file["title"] = file.name;

    this.updateFilesList([...[file], ...this._updatedList]);
  }

  /**
   * Event of file loading and binary conversion
   * @param file
   */
  onFileUpload(file) {
    this.getPayloadFile(file).subscribe(payload => {
      this.prepareFilesList(file);
      this.uploadDocumentToApi(payload, file);
    });
  }

  public getPayloadFile(file: any): Observable<{ fileData: {}; }> {

    return new Observable((observer: Subscriber<{ fileData: {}; }>): void => {

      let obj = {
        fileName: file.name,
        error: false,
      };
      this._uploadError.next(obj);
      //this.prepareFilesList(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      let imgBase64;
      reader.onload = () => {
        let payload = { fileData: {} };
        imgBase64 = reader.result;
        const content = this.onDecodeUri(imgBase64);
        payload.fileData["content"] = content;
        payload.fileData["nomeFile"] = file.name;
        payload.fileData["contentType"] = file.type;
        payload.fileData["creatore"] = this.userManager.getUser().username;
        payload.fileData["descrizione"] = file.name;
        payload.fileData["contentSize"] = file.size;
        observer.next(payload);
        observer.complete();

      };
    });

  }

  /**
   * @POST
   * http request file upload
   * @param payload
   * @param file
   */
  uploadDocumentToApi(payload, file) {
    // FILE UPLOAD @POST
    const upload$ = this.http
      .post<FileDataResponse>(
        ServicePathsSettings.DOMINIO +
          // ServicePathsSettings.URL_UPLOAD_DOCUMENTO,
          ServicePathsSettings.URL_UPLOAD_DOCUMENTO_TEMP,
          payload,
        {
          reportProgress: true,
          observe: "events",
        }
      )
      .pipe(
        map((result: any) => {
          // FILE UPLOAD ERROR HANDLING
          if (result.status && result.status !== 200) {
            let obj = {
              fileName: file.name,
              error: true,
            };
            this._uploadError.next(obj);
          }
          return result;
        })
      );

    this.onEventTracking(upload$, file);
  }



  /**
   * keep track of signle event of file uploading progress and response
   * @param upload$ http observable
   * @param file uploaded file
   */
  private onEventTracking(upload$, file: any) {
    upload$.subscribe((event) => {
      if (event.type == HttpEventType.UploadProgress) {
        const uploadProgress = Math.round(100 * (event.loaded / event.total));
        let obj = {
          fileName: file.name,
          progress: uploadProgress,
        };
        this._uploadProgress.next(obj);
      }
      if (event.type == HttpEventType.Response) {
        const index = this._updatedList.findIndex(el => el.name === file.name);
        this._updatedList[index].refDocumentale = event.body.fileData.refDocumentale;
        this._updatedList[index]["nomeFile"] = event.body.fileData.nomeFile;
        this._updatedList[index]["contentType"] = event.body.fileData.contentType;
        this._updatedList[index]["versione"] = event.body.fileData.versione;
        this.updateFilesList([...this._updatedList]);
      }
    });
  }

  onDecodeUri(dataURI: string) {
    const splitDataURI = dataURI.split(',')
    return decodeURI(splitDataURI[1])
  }

}
